var AllhomesMapStyle = [{
  featureType: 'administrative',
  elementType: 'all',
  stylers: [{
    saturation: '-100'
  }]
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{
    saturation: -100
  }, {
    lightness: 65
  }, {
    visibility: 'off'
  }]
}, {
  featureType: 'landscape.man_made',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#e2e7ef'
  }]
}, {
  featureType: 'landscape.man_made',
  elementType: 'geometry.stroke',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#fafbfc'
  }]
}, {
  featureType: 'landscape.natural',
  elementType: 'geometry',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#e5eaf1'
  }]
}, {
  featureType: 'poi',
  elementType: 'all',
  stylers: [{
    saturation: -100
  }, {
    lightness: '50'
  }, {
    visibility: 'off'
  }]
}, {
  featureType: 'poi',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#cfd7e5'
  }]
}, {
  featureType: 'road',
  elementType: 'all',
  stylers: [{
    saturation: '-100'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'all',
  stylers: [{
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#a8b0be'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'all',
  stylers: [{
    lightness: '30'
  }]
}, {
  featureType: 'road.local',
  elementType: 'all',
  stylers: [{
    lightness: '40'
  }]
}, {
  featureType: 'transit',
  elementType: 'all',
  stylers: [{
    saturation: -100
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'transit.station',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#d7dee9'
  }]
}, {
  featureType: 'water',
  elementType: 'geometry',
  stylers: [{
    hue: '#ffff00'
  }, {
    lightness: -25
  }, {
    saturation: -97
  }]
}, {
  featureType: 'water',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#b7bfcd'
  }]
}, {
  featureType: 'water',
  elementType: 'labels',
  stylers: [{
    lightness: -25
  }, {
    saturation: -100
  }]
}];
export default AllhomesMapStyle;